import { Button } from "@mui/material";
import { cancelButtonSx, primaryButtonSx, formActionsClass } from "./addSourceStyles";

interface SourceFormFooterProps {
  onCancel: () => void;
  submitLabel: string;
  disabled?: boolean;
  cancelLabel?: string;
}

export function SourceFormFooter({
  onCancel,
  submitLabel,
  disabled = false,
  cancelLabel = "Cancel",
}: SourceFormFooterProps) {
  return (
    <div className={formActionsClass}>
      <Button type="button" variant="outlined" onClick={onCancel} sx={cancelButtonSx}>
        {cancelLabel}
      </Button>
      <Button type="submit" variant="contained" disabled={disabled} sx={primaryButtonSx}>
        {submitLabel}
      </Button>
    </div>
  );
}
